export const botEngineConfig = () => {
  return{
    baseUrl: (window as any).REACT_APP_BOT_ENGINE_BASE_URL || process.env.REACT_APP_BOT_ENGINE_BASE_URL,
  }
}